export default [

    {
        name: '0.5',
        qty: 0.5
    },
    {
        name: '1',
        qty: 1.0
    },
    {
        name: '1.5',
        qty: 1.5
    },
    {
        name: '2',
        qty: 2.0
    },
    {
        name: '2.5',
        qty: 2.5
    },
    {
        name: '3',
        qty: 3.0
    },
    {
        name: '3.5',
        qty: 3.5
    },
    {
        name: '4',
        qty: 4.0
    },
    {
        name: '4.5',
        qty: 4.5
    },
    {
        name: '5',
        qty: 5.0
    },
    {
        name: '5.5',
        qty: 5.5
    },
    {
        name: '6',
        qty: 6.0
    },
    {
        name: '6.5',
        qty: 6.5
    },
    {
        name: '7',
        qty: 7.0
    },
    {
        name: '7.5',
        qty: 7.5
    },
    {
        name: '8',
        qty: 8.0
    },
    {
        name: '8.5',
        qty: 8.5
    },
    {
        name: '9',
        qty: 9.0
    },
    {
        name: '9.5',
        qty: 9.5
    },
    {
        name: '10',
        qty: 10.0
    },
    {
        name: '10.5',
        qty: 10.5
    },
    {
        name: '11',
        qty: 11.0
    },
    {
        name: '11.5',
        qty: 11.5
    },
    {
        name: '12',
        qty: 12.0
    },
    {
        name: '12.5',
        qty: 12.5
    },
    {
        name: '13',
        qty: 13.0
    },
    {
        name: '13.5',
        qty: 13.5
    },
    {
        name: '14',
        qty: 14.0
    },
    {
        name: '14.5',
        qty: 14.5
    },
    {
        name: '15',
        qty: 15.0
    },
    {
        name: '15.5',
        qty: 15.5
    },
    {
        name: '16',
        qty: 16.0
    },
    {
        name: '16.5',
        qty: 16.5
    },
    {
        name: '17',
        qty: 17.0
    },
    {
        name: '17.5',
        qty: 17.5
    },
    {
        name: '18',
        qty: 18.0
    },
    {
        name: '18.5',
        qty: 18.5
    },
    {
        name: '19',
        qty: 19.0
    },
    {
        name: '19.5',
        qty: 19.5
    },
    {
        name: '20',
        qty: 20.0
    }

  ];